import GeneralFailure from './general-failure.vue';

export default GeneralFailure;
